export default __webpack_public_path__ + "static/media/insurance.d546753c.png";